import React from 'react';
import clsx from 'clsx';
import { CancelButton, ConfirmButton } from '../../../../../styling/Styles';
import { checkIfNameExists, checkIfEmpty } from '../../../../../validations/validations';

const convertoToJavascriptFile = (javascriptFunctions) => {
  let javascriptFile = '';

  javascriptFunctions.forEach((func) => {
    javascriptFile = `${javascriptFile}function ${func.functionName}() ${func.functionality}\n`;
  });

  javascriptFunctions.forEach((func) => {
    func.compIds.forEach((compId) => {
      javascriptFile = `${javascriptFile}document.getElementById('${compId}').onclick = ${func.functionName};\n`;
    });
  });

  return javascriptFile;
};

/*
This component renders inside every edit general pop up window the row that is responsible for the buttons - actions of the pop up.
*/
const FunctionsRow = ({
  setOpenAlert,
  setClickedEdit,
  lock,
  selectedProject,
  savedPageClicked,
  editor,
  targetPageChecked,
  hrefChecked,
  annotationName,
  annotationType,
  attributeType,
  annotationValue,
  newSelected,
  entity,
  entityName,
  functionName,
  attributeParam,
  valueParam,
  logicalOperatorParam,
  comparisonOperatorParam,
  annotationTable,
  customAttributeType,
  attributeTypeService,
  displayFlowData,
  displayAnnotationData,
  targetPage,
  href,
  newWindowChecked,
  advanceSelectObject,
  transitionById,
  isAdvanceSelect,
  annotationTarget,
  previousPageChecked,
  insertCustomCodeChecked,
  serviceSelectedAttr,
  headers,
  bodyParams,
  queryParams,
  connectedService,
  paramType,
  requestParam,
  defineServiceParam,
  error,
  setError
}) => {

  // This function closes the edit  pop up window
  const handleCancel = () => {
    setError(false);
    setClickedEdit(false);
    setOpenAlert(false);
  };

  const findId = (pageName) => {
    let id = -1;
    const tempData = JSON.parse(localStorage.getItem('data'));
    tempData[selectedProject].pages.forEach((page) => {
      if (page.name === pageName) {
        id = page.pageId;
      }
    });
    return id;
  };

  const updateChangeJavascript = () => {
    const selectedPage = JSON.parse(localStorage.getItem('selectedPage'));
    const projectsData = JSON.parse(localStorage.getItem('data'));

    projectsData[selectedProject].pages[selectedPage].javascript.changeJavascript = true;
    let customFunctions =
      projectsData[selectedProject].pages[selectedPage].javascript.customFunctions || [];
    if (insertCustomCodeChecked === true && editor.getSelected().attributes.script !== '') {
      let foundCustomFunction = false;
      customFunctions.forEach((customFunction, index) => {
        if (customFunction.id === editor.getSelected().attributes.attributes.id) {
          foundCustomFunction = true;
          customFunctions[index].customFunction = editor.getSelected().attributes.script;
        }
      });

      if (foundCustomFunction === false) {
        customFunctions.push({
          id: editor.getSelected().attributes.attributes.id,
          customFunction: editor.getSelected().attributes.script
        });
      }
    } else {
      customFunctions = customFunctions
        .filter((func) => func.id !== editor.getSelected().attributes.attributes.id)
        .map((func) => func);
      editor.getSelected().set('script', '');
    }
    projectsData[selectedProject].pages[selectedPage].javascript.customFunctions = customFunctions;
    localStorage.setItem('data', JSON.stringify(projectsData));
  };

  /**
   * @param {object} attr - array of grape's component attributes
   * @param {array} attrNames - Array of attributes' names
   * @return {array} - Array without attribute in attrNames
   */
  const removeAttributes = (attr, attrNames) =>
    Object.fromEntries(
      Object.keys(attr)
        .filter((key) => !attrNames.includes(key))
        .map((key) => [key, attr[key]])
    );
  const updateServiceParameters = () => {
    const component = editor.getSelected();
    if (defineServiceParam === false) {
      const attr = component.getAttributes();
      delete attr['service-name'];
      delete attr['type-param'];
      delete attr['request-param'];
      component.setAttributes(attr);
    } else {
      component.addAttributes({ 'service-name': connectedService });
      component.addAttributes({ 'type-param': paramType });
      component.addAttributes({ 'request-param': requestParam });
    }
  };

  // This function updates the flow attributes of a component that has flow attributes
  const updateFlowAttributes = () => {
    const component = editor.getSelected();

    if (displayFlowData === false) {
      component.setAttributes(
        removeAttributes(component.getAttributes(), [
          'target_page',
          'href',
          'open-window',
          'transition-by-id',
          'attached-subentity-attr',
          'back-button',
          'insert-code'
        ])
      );
      component.removeClass('pointer');
    }

    if (targetPageChecked === true) {
      const attr = component.getAttributes();
      if (attr.target_page === 'none') {
        component.setAttributes(removeAttributes(attr, ['target_page', 'transition-by-id']));
        if (hrefChecked === false && previousPageChecked === false)
          component.removeClass('pointer');
      } else {
        if (transitionById === true) {
          component.addAttributes({ 'transition-by-id': true });
        } else {
          delete attr['transition-by-id'];
          component.setAttributes(removeAttributes(attr, ['transition-by-id']));
        }
        component.addAttributes({ target_page: findId(targetPage) });
        component.addClass('pointer');
      }
    } else {
      const attr = component.getAttributes();
      component.setAttributes(removeAttributes(attr, ['target_page', 'transition-by-id']));
      if (
        hrefChecked === false &&
        previousPageChecked === false &&
        insertCustomCodeChecked === false
      )
        component.removeClass('pointer');
    }

    if (hrefChecked === false || (hrefChecked === true && href === '')) {
      const attr = component.getAttributes();
      component.setAttributes(removeAttributes(attr, ['href']));
      if (
        targetPageChecked === false &&
        previousPageChecked === false &&
        insertCustomCodeChecked === false
      ) {
        component.removeClass('pointer');
      }
    } else {
      component.addClass('pointer');
      component.addAttributes({ href });
    }

    if (insertCustomCodeChecked === false) {
      const attr = component.getAttributes();
      component.setAttributes(removeAttributes(attr, ['insert-code']));
      if (targetPageChecked === false && hrefChecked === false && previousPageChecked === false) {
        component.removeClass('pointer');
      }
    } else {
      component.addClass('pointer');
      component.addAttributes({ 'insert-code': true });
    }

    if (previousPageChecked === false) {
      const attr = component.getAttributes();
      component.setAttributes(removeAttributes(attr, ['back-button']));
      if (
        targetPageChecked === false &&
        hrefChecked === false &&
        insertCustomCodeChecked === false
      ) {
        component.removeClass('pointer');
      }
    } else {
      component.addClass('pointer');
      component.addAttributes({ 'back-button': true });
    }

    if (newWindowChecked === true) {
      const attr = component.getAttributes();
      if (
        (hrefChecked === true && attr.href !== '') ||
        (attr.target_page !== 'none' && targetPageChecked === true)
      ) {
        component.addAttributes({ 'open-window': true });
      } else {
        component.setAttributes(removeAttributes(attr, ['open-window']));
      }
    } else {
      const attr = component.getAttributes();
      component.setAttributes(removeAttributes(attr, ['open-window']));
    }

    if (isAdvanceSelect === true) {
      component.addAttributes({ 'attached-subentity-attr': annotationTarget });
    } else {
      component.setAttributes(
        removeAttributes(component.getAttributes(), ['attached-subentity-attr'])
      );
    }

    updateChangeJavascript();
  };

  /**
   *  addOrRemoveAttribute - this function wraps a procedure which manipulates
   * grape-component's attribute array.
   * @param {} component grape component
   * @param {Object} attribute html-attribute pair key-value (grape attributes
   * are case sensitive) keys are forced to lowcase
   * @param {boolean} condition  true -> add false -> remove
   */
  function addOrRemoveAttribute(component, attribute, condition) {
    const [key, value] = Object.entries(attribute)[0];
    if (condition) {
      //  TODO this is higly should go with attribute Object.entries()
      component.addAttributes({ [key.toLocaleLowerCase()]: value });
    } else {
      const attr = component.getAttributes();
      delete attr[key.toLocaleLowerCase()];
      component.setAttributes(attr);
    }
  }

  const checkIfAnnotationNameExists = () => {
    let exists = -1;

    const tempData = JSON.parse(localStorage.getItem('data'))[selectedProject];

    if (
      tempData.annotations[0] !== undefined &&
      tempData.annotations[0].combinations !== undefined
    ) {
      tempData.annotations[0].combinations.forEach((combination, index) => {
        if (combination.annotationName === annotationName) {
          exists = index;
        }
      });
    }

    return exists;
  };

  const handleNumberType = (component) => {
    if (attributeType === 'number') {
      if (component.attributes.attributes.type !== 'number') {
        component.addAttributes({ type: 'number' });
      }
    } else if (component.attributes.attributes.type === 'number') {
      const attr = component.getAttributes();
      delete attr.type;
      component.setAttributes(attr);
    }
  };

  // This function updates the annotations attributes on a given component.
  const updateAnnotations = (component) => {
    const tempData = JSON.parse(localStorage.getItem('data'));
    if (tempData[selectedProject].annotations[0] === undefined) {
      tempData[selectedProject].annotations.push({ combinations: [], entities: [] });
    }
    if (checkIfAnnotationNameExists() !== -1) {
      const combination =
        tempData[selectedProject].annotations[0].combinations[checkIfAnnotationNameExists()];

      combination.annotationName = annotationName;
      combination.annotationType = annotationType;
      combination.attributeType = attributeType;
      combination.customAttributeType = customAttributeType;
      combination.attributeTypeService = attributeTypeService;
      combination.annotationTable = annotationTable;
      combination.method = functionName;
      if (annotationType === 'method' && functionName.startsWith('getByParams')){
        combination.attributeParam = attributeParam;
        combination.valueParam = valueParam;
        combination.logicalOperatorParam = logicalOperatorParam;
        combination.comparisonOperatorParam = comparisonOperatorParam;
      }
      if (attributeType === 'service') {
        combination.serviceAttr = serviceSelectedAttr;
      } else {
        combination.serviceAttr = '';
      }
      if (combination.method.startsWith('service') === true) {
        combination.serviceParams = {
          headers,
          queryParams,
          bodyParams
        };
      } else {
        combination.serviceParams = {
          headers: null,
          queryParams: null,
          bodyParams: null
        };
      }
      if (newSelected === true) {
        combination.annotationLink = entityName;
      } else {
        combination.annotationLink = entity;
      }
    } else {
      const { combinations } = tempData[selectedProject].annotations[0];
      let annotationLink = '';
      let serviceAttr = '';
      let serviceParams = {};
      if (annotationType === 'method' && functionName.startsWith('getByParams')){
        attributeParam = attributeParam;
        valueParam = valueParam;
        logicalOperatorParam = logicalOperatorParam;
        comparisonOperatorParam = comparisonOperatorParam;
      } else {
        attributeParam = 'none';
        valueParam = 'none';  
        logicalOperatorParam = 'none';
        comparisonOperatorParam = 'none';
      }
      if (newSelected === true) {
        annotationLink = entityName;
      } else {
        annotationLink = entity;
      }
      if (attributeType === 'service') {
        serviceAttr = serviceSelectedAttr;
      } else {
        serviceAttr = '';
      }
      if (functionName.startsWith('service') === true) {
        serviceParams = {
          headers,
          queryParams,
          bodyParams
        };
      } else {
        serviceParams = {
          headers: null,
          queryParams: null,
          bodyParams: null
        };
      }
      if (combinations !== undefined && annotationName !== '') {
        combinations.push({
          annotationName,
          annotationType,
          attributeType,
          customAttributeType,
          attributeTypeService,
          annotationTable,
          method: functionName,
          attributeParam,
          valueParam,
          logicalOperatorParam,
          comparisonOperatorParam,
          annotationLink,
          serviceAttr,
          serviceParams
        });
      }
    }
    localStorage.setItem('data', JSON.stringify(tempData));
    handleNumberType(component);
    addOrRemoveAttribute(component, { annotationName }, annotationName !== '');
  };

  // This function takes radio value that has been given inside edit pop up and updates label value of component.
  const updateRadioValue = (component) => {
    if (
      annotationValue !== 'none' &&
      (attributeType === 'radiobox' || attributeType === 'checkbox') &&
      annotationType === 'attribute'
    ) {
      component.components(annotationValue);
    }
  };

  const updateAnnotationValues = (component) => {
    if (
      annotationValue !== 'none' &&
      (attributeType === 'radiobox' || attributeType === 'checkbox') &&
      annotationType === 'attribute'
    ) {
      const compId = component.attributes.attributes.id;

      const grandParentComp = component.parent().parent();
      const siblings = grandParentComp.find(`label`);
      siblings.forEach((sibling) => {
        if (sibling.attributes.attributes.id !== compId) {
          let compContent = '';

          try {
            compContent = sibling.view.$el[0].innerText;
          } catch (e) {
            compContent = '';
          }
          addOrRemoveAttribute(sibling, { annotationValue: compContent }, true);
        } else {
          addOrRemoveAttribute(sibling, { annotationValue }, true);
        }
      });
    }
  };

  /*
    This function checks if parent of selected component is radio. Then checks if exist other radio components near our radio component.If exist
    then it assigns the same annotation attributes to the labels inside all  radios components.
    */
  const updateMultipleTags = (componentParent, wablitype) => {
    componentParent
      .parent()
      .attributes.components.models.filter(
        (sibling) =>
          sibling.attributes.attributes.wablitype !== undefined &&
          sibling.attributes.attributes.wablitype === wablitype
      )
      .reduce((children, sibling) => children.concat(sibling.attributes.components.models), [])
      .filter((child) => child.attributes.tagName === 'label')
      .forEach((label) => updateAnnotations(label));
  };

  /*
    This function updates the entities if a new entity inside the project is given and the annotations if a new annotation name inside
    the project is given
  */
  const updateAnnotationsEntities = () => {
    const tempData = JSON.parse(localStorage.getItem('data'));
    const selectedPage = JSON.parse(localStorage.getItem('selectedPage'));

    const tempDataEntities = tempData[selectedProject].annotations[0].entities;


    if (annotationType === 'algorithmic resource') {
      let page = tempData[selectedProject].pages[selectedPage];
      tempData[selectedProject].pages[selectedPage] = addToPageSchema(page, {
        entryName: annotationName,
        entryType: annotationType,
        table: annotationTable,
        UIProps: {}
      })
    }
    if (
      checkIfNameExists(entityName, tempDataEntities) === false &&
      checkIfEmpty(entityName) === false &&
      newSelected === true
    ) {
      tempData[selectedProject].annotations[0].entities.push(entityName);
    }
    if (
      checkIfNameExists(customAttributeType, tempDataEntities) === false &&
      checkIfEmpty(customAttributeType) === false
    ) {
      tempData[selectedProject].annotations[0].entities.push(customAttributeType);
    }

    localStorage.setItem('data', JSON.stringify(tempData));
  };

  const wabliTypesToMultipleTags = new Set(['radios', 'checkboxes', 'inline-radios']);
  /*
    This function updates the annotation attributes of a general component.Also if component is radio then assign same annotation
    attributes to near radios components.
  */
  const updateDataAttributes = () => {
    const component = editor.getSelected();

    if (displayAnnotationData === true) {
      updateAnnotations(component);

      if (
        component.parent() !== undefined &&
        component.parent() !== null &&
        component.parent().attributes.attributes.wablitype !== undefined &&
        wabliTypesToMultipleTags.has(component.parent().attributes.attributes.wablitype)
      ) {
        updateMultipleTags(component.parent(), component.parent().attributes.attributes.wablitype);
      }

      updateAnnotationValues(component);
      updateRadioValue(component);
      updateAnnotationsEntities();

    } else {
      const attr = component.getAttributes();
      delete attr.annotationname;
      component.setAttributes(attr);
    }
  };

  /**
   * This function updates the advance select options with the optionAnnotationName
   * @param {grapeJs component} component - The <select> component
   * @param {object} selectObject - User defined select properties
   */
  function updateAdvanceSelect(component, selectObject) {
    if (!component) return;

    addOrRemoveAttribute(component, { 'advance-select': true }, selectObject.checked === true);
    component.attributes.components.models.forEach((child) => {
      if (child.attributes.tagName === 'option') {
        addOrRemoveAttribute(
          child,
          { annotationName: selectObject.optionAnnotationName },
          child.attributes.tagName === 'option' && selectObject.checked === true
        );
        addOrRemoveAttribute(child, { dataitem: 'true' }, child.attributes.tagName === 'option');
      }
    });
  }

  /**
   * @param {Object} page
   * @param {Object} schema
   * @return {Object} page
   */
  const addToPageSchema = (page, schema) => {
    console.log("schema to be inserted", schema);
    const schemas = page.data[0].schema;
    console.log(schemas)
    if (schemas.findIndex((entry) => entry.entryName === schema.entryName) > -1)
      return page
    schemas.push(schema);
    console.log(schemas);
    page.data[0].schema = schema;
    return page;
  }

  const updateAttributes = async () => {

    if(annotationType === 'method' && functionName.startsWith('getByParams') === true){
      /* eslint-disable no-plusplus */
      for(let i = 0; i < attributeParam.length; i++){
            if(attributeParam[i] === "" || attributeParam[i] === 'none'){
              setError(true);
              return;
            }
          }
      /* eslint-disable no-plusplus */
      for(let i = 0; i < valueParam.length; i++){
        if(valueParam[i] === "" || valueParam[i] === 'none'){
          setError(true);
          return;
        }
      }
      /* eslint-disable no-plusplus */
      for(let i = 0; i < comparisonOperatorParam.length; i++){
        if(comparisonOperatorParam[i] === "" || comparisonOperatorParam[i] === 'none'){
          setError(true);
          return;
        }
      }
      /* eslint-disable no-plusplus */
      for(let i = 0; i < (logicalOperatorParam.length - 1); i++){
        if(logicalOperatorParam[i] === "" || logicalOperatorParam[i] === 'none'){
          setError(true);
          return;
        }
      }
    }
    

    if (lock === false) {
      setError(false);
      updateFlowAttributes();
      updateDataAttributes();
      updateServiceParameters();
      updateAdvanceSelect(editor.getSelected(), advanceSelectObject, isAdvanceSelect);
      savedPageClicked();
      setOpenAlert(false);
      setClickedEdit(false);
    }
  };

  return (
    <div
      className={clsx('flex-container', 'spacingDownDiv')}
      style={{
        justifyContent: 'space-between',
        display: 'flex',
        flexDirection: 'row',
        marginTop: '1.5vw'
      }}
    >
      <div>
        <CancelButton onClick={handleCancel}>Cancel</CancelButton>
      </div>
      <div style={{ alignItems: 'center'}} className={clsx('flexRowDirection')}>
        
      {error === true && <p style={{ paddingRight: '5px', color: 'red'}}>*Please fill empty fields first.</p>}
        <ConfirmButton id="saveEditDataElement" onClick={updateAttributes}>
          Save
        </ConfirmButton>
        <div> &nbsp;</div>
      </div>
    </div>
  );
};

export default FunctionsRow;
export { convertoToJavascriptFile };
